<div class="row">
  <div class="col-12 col-md-3">
    <a
      [attr.aria-label]="
        !product.images?.hasOwnProperty('PRIMARY')
          ? ('productDetails.noProductImage'
            | cxTranslate : { product: product.name })
          : undefined
      "
      [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
      class="cx-product-image-container"
    >
      <cx-media
        class="cx-product-image"
        [container]="product.images?.PRIMARY"
        format="product"
        [alt]="product.name || product.summary"
      ></cx-media>
    </a>
  </div>
  <div class="col-12 col-md-4">
    <a
      [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
      class="cx-product-name"
    >
      <h2 [innerHtml]="product.nameHtml"></h2>
    </a>

    <ng-template [cxOutlet]="ProductListOutlets.ITEM_DETAILS">
      <div *ngIf="product?.code">
        {{ "productList.productCode" | cxTranslate }} {{ product.code }}
      </div>
      <div
        class="cx-product-price"
        [attr.aria-label]="'productDetails.productPrice' | cxTranslate"
      >
        {{ product.price?.formattedValue }}
      </div>
    </ng-template>
  </div>
  <div class="col-12 col-md-5">
    <app-add-to-ekcart
      [productCode]="product?.code"
      [showQuantity]="true"
    ></app-add-to-ekcart>
  </div>
</div>
